<template>
    <el-select v-model="valueData"
        @visible-change="onVisibleChange"
        @change="onChange">
        <el-option :value="-1" label="指定人处理"></el-option>
        <el-option v-for="item in workflowList"
            :key="item.id"
            :label="item.name"
            :value="item.id"></el-option>
    </el-select>
</template>

<script>
export default {
    name : 'WorkflowSelect',

    data() {
        return {
            valueData : -1,
            workflowList : []
        }
    },

    mounted() {
        this.loadMyWorkflow();
    },

    methods : {
        onVisibleChange(v) {
            setTimeout(() => {
                $('div.el-select-dropdown.el-popper').css('z-index', 20000);
            }, 100);
        },

        setValue( _val ) {
            this.valueData = _val;
        },

        onChange() {
            var _this = this;
            var workflow = this.workflowList.filter(e => e.id == _this.valueData);
            this.$emit('change', this.valueData, workflow);
        },

        loadMyWorkflow() {
            var _this = this;
            sdk.TicketWorkflowApi().listMyWorkflowCached({
                page : { pageSize : 9999, orderBy : '`index` DESC' }
            }).then(res => {
                _this.workflowList = res.list;
            });
        }
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/ticket/WorkflowSelect.vue